/* eslint-disable */
import React, { Component } from 'react';
import {
  css
} from 'aphrodite';
import { Styles } from './Styles'
import 'rc-slider/assets/index.css';
import { SlideDown } from 'react-slidedown'
import 'react-slidedown/lib/slidedown.css'
import Grid from '@material-ui/core/Grid';
import Icon from '@material-ui/core/Icon';
import { ChartCard } from '../../common/components/ChartCard'
import { Helper } from '../../common/helpers/Helper';
import Tooltip from '@material-ui/core/Tooltip';
import CircularProgress from '@material-ui/core/CircularProgress';
import FormControl from '@material-ui/core/FormControl';
import { CheckboxComponent } from '../../components/CheckboxComponent';
import { appData } from '../../data/AppData';


import TextField from '@material-ui/core/TextField';

export class ChartComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      chartType: ["bar"],
      chartTime: ["daily"],
      reportTitle:''
    }
  }

  componentWillMount() {
  }

  chartTypeHandler = (value) => {
    this.setState({ chartType: value })
  }

  chartTimeHandler = (value) => {
    this.setState({ chartTime: value })
  }

  outerHeaderStatCardStyle = () => {
    if (!this.props.orgLevel) {
      return css(Styles.outerHeaderStatCard, Styles.outerHeaderStatCardSpec)
    } else {
      return css(Styles.outerHeaderStatCard)
    }
  }

  reportTitlechange = (e, v) => {
    this.setState({
      reportTitle:e.target.value
    })
  }

  render = () => {

    return (
      <>
        
      <SlideDown className={'my-dropdown-slidedown'}>

        {this.props.showChart ?
          <div className={css(Styles.outerHeaderStatCard)}>
            <div className={css(Styles.statContainer, Styles.statContainerSpec)}>
              <div className={css(Styles.statContainerTitle)}>
                <Icon
                  className={css(Styles.barChartIcon)}>
                  bar_chart
                </Icon>
                <p className={css(Styles.statTitle)}>Reports</p>

                <div className={css(Styles.statCollapse)}>

                  <FormControl className={css(Styles.inputCss)}>
                    <CheckboxComponent
                      inputCss={Styles.mb0}
                      formField={appData.chartIntervalFields}
                      value={this.state.chartTime}
                      disabled={false}
                      setValue={this.chartTimeHandler}
                    />
                  </FormControl>

                  <FormControl className={css(Styles.inputCss)}>

                    <CheckboxComponent
                      inputCss={Styles.mb0}
                      formField={appData.chartFields}
                      value={this.state.chartType}
                      disabled={false}
                      setValue={this.chartTypeHandler}
                    />
                  </FormControl>
                  {/* <div className={css(Styles.downloadContainer)}>
                    <Tooltip title={'Download Chart'}>
                      <div className={css(Styles.downloadImage)} onClick={() => this.props.handleCaptureClick(false, this.state.reportTitle ? this.state.reportTitle : '')}>
                        <img src={require('../../assets/images/download-img1.svg')} />
                      </div>
                    </Tooltip>
                  </div> */}
                    
                    {this.props.chartSummaryInProgress ?
                      <div>
                        <CircularProgress color='#ffffff' size={30} />
                      </div>
                      :
                      <div className={css(Styles.downloadContainer)}>
                        <Tooltip title={'Download Chart with Cam Summary'}>
                          <div className={css(Styles.downloadImage)} onClick={() => this.props.handleCaptureClick(true, this.state.reportTitle ? this.state.reportTitle : '')}>
                            <img src={require('../../assets/images/download-img1.svg')} />
                          </div>
                        </Tooltip>
                      </div>
                    }
                  <Icon
                    onClick={() => this.props.showChartHandler(!this.props.showChart)}
                    className={css(Styles.statsUpIcon)}>
                    keyboard_arrow_up
                  </Icon>
                </div>
              </div>
              {(!this.props.data || !this.props.data.length) &&
                <div className={css(Styles.noItemsToShow)}>
                  <p>{Helper.getString('noItemsFound')}</p>
                </div>
              }
              {this.props.data && this.props.data.length > 0 &&
                // <Grid container spacing={2} className={css(Styles.gridContainerVariant)} ref={this.props.captureRef} >
                //   <Grid container spacing={2}>
                //   <img src={this.props.logo} />
                //   </Grid>
                //   {
                //     (this.props.data && this.props.data.length > 0) &&
                //     this.props.data.map((item, index) => (

                //       item.title && (this.state.chartTime.some((criterion) => item.title.toLowerCase().includes(criterion.toLowerCase()))) ?
                //         this.state.chartType.map((i) => {
                //           if (i != "selectAll") {
                //             return <ChartCard
                //               type={i}
                //               chartType={this.state.chartType}
                //               key={index}
                //               item={item}
                //               show={item.labels.length > 0 && item.datasets.length > 0 && item.title != "Active time"}
                //             />
                //           }
                //         })
                //         : <></>
                //     ))
                //   }
                // </Grid>
                  <Grid container spacing={2} className={css(Styles.gridContainerVariant)}>
                    {/* <Grid container justifyContent="center" alignItems="center">
                  <img 
                    src={this.props.logo} 
                    alt="Logo"
                    style={{ 
                      // maxWidth: '5rem', 
                      // maxHeight: '5rem',
                      // display: 'block'
                    }} 
                      />
                    </Grid> */}
                    <FormControl className={css(Styles.mb2r, Styles.brdrDark)}>
                      <TextField
                        placeholder={'Enter Report title'}
                        onChange={(e) => this.reportTitlechange(e)}
                        {...this.props}
                        className={css(Styles.inputCss)}
                        InputProps={{
                          disableUnderline: true,
                          classes: {
                            root: css(Styles.textFieldContentInput),
                            input: css(Styles.inputText),
                          }
                        }}
                        InputLabelProps={{
                          classes: {
                            root: css(Styles.textFieldContent),
                          }
                        }}
                      />
                    </FormControl>
                    <Grid container justifyContent="center" alignItems="center" style={{ padding: '3rem', border: "1px solid" }}  ref={this.props.captureRef}>

                      {(this.props.data && this.props.data.length > 0) &&
                        this.props.data.map((item, index) => (
                         item && item.title && (this.state.chartTime.some((criterion) =>
                            item.title.toLowerCase().includes(criterion.toLowerCase()))) ?
                            this.state.chartType.map((i) => {
                              
                              if (i != "selectAll") {

                                return <ChartCard
                                  type={i}
                                  chartType={this.state.chartType}
                                  key={index}
                                  item={item}
                                  show={item.labels.length > 0 && item.datasets.length > 0 && item.title != "Active time"}
                                  handleChartClick={this.props.handleChartClick}

                                />
                              }
                              return null;
                            })
                            : <React.Fragment key={index}></React.Fragment>
                        ))
                      }
                    </Grid>
                  </Grid>
                }
              </div>
          </div>
          :
          null
        }
      </SlideDown>
      </>
    )
  }
}